module.exports = __webpack_public_path__ + "img/SAP_9030.efe7082b.jpg";